export default {
  v3SubmitErrBtnViewOrder: 'Visualizza Ordine',
  v3SubmitErrBtnBackHome: 'Home',
  v3SubmitErrBtnRetry: 'Riprova',
  v3SubmitErrBtnRelogin: 'Rieffettua il login',
  v3SubmitErrBtnSwitchPay: 'Cambia metodo di pagamento',
  v3SubmitErrBtnReorder: 'Riordina',
  v3SubmitErrBtnSwitchServer: 'Cambia server',
  v3SubmitErrBtnViewOrderStatus: 'Stato ordine',
  v3SubmitErrBtnBackStore: 'Torna al negozio',
  v3SubmitErrBtnGoUpdate: 'Aggiorna',
  v3SubmitErrBtnResubscribe: 'Riabbonati',
  v3SubmitErrTipUpdateApp: 'Aggiorna tramite l\'App Store',
  v3SubmitErrTipRelogin: 'Effettua di nuovo il login',

  v3SubmitErrMsg120009: 'Ordine elaborato – controlla lo zaino in gioco.',
  v3SubmitErrMsg120003: 'Errore informazioni prodotto – seleziona di nuovo.',
  v3SubmitErrMsg120016: 'Troppe richieste – attendi qualche secondo e riprova.',
  v3SubmitErrMsg120025: 'Parametri di richiesta anomali – effettua di nuovo il login e riprova.',
  v3SubmitErrMsg121012: 'Canale di pagamento temporaneamente non disponibile – prova un altro metodo.',
  v3SubmitErrMsg120012: 'Rete instabile – controlla la connessione e riprova.',
  v3SubmitErrMsg120002: 'Personaggio non trovato – creane uno prima.',
  v3SubmitErrMsg121019: 'Errore nelle informazioni dell\'ordine – effettua un nuovo ordine.',
  v3SubmitErrMsg120024: 'Regalo pre-registrazione già ritirato – non ripetere.',
  v3SubmitErrMsg120000: 'Login scaduto – effettua di nuovo il login.',
  v3SubmitErrMsg120014: 'Numero ordine non valido – effettua un nuovo ordine.',
  v3SubmitErrMsg121001: 'Ricarica in gioco fallita – riprova più tardi o contatta l\'assistenza.',
  v3SubmitErrMsg120015: 'Importo di pagamento anomalo – seleziona di nuovo il prodotto.',
  v3SubmitErrMsg120001: 'Server non corrispondente – passa al server corretto.',
  v3SubmitErrMsg120020: 'Il canale di pagamento ha restituito un errore – prova un altro metodo.',
  v3SubmitErrMsg120010: 'Funzione di ricarica temporaneamente disattivata – riprova più tardi.',
  v3SubmitErrMsg120006: 'Verifica importo fallita – seleziona di nuovo.',
  v3SubmitErrMsg121010: 'Richiesta di ricarica in sandbox non valida – usa la versione ufficiale.',
  v3SubmitErrMsg120017: 'Numero ordine duplicato – controlla se già pagato.',
  v3SubmitErrMsg120022: 'Verifica callback di pagamento fallita – riprova più tardi.',
  v3SubmitErrMsg121000: 'Sistema occupato – riprova più tardi.',
  v3SubmitErrMsg120011: 'ID prodotto errato – seleziona di nuovo.',
  v3SubmitErrMsg121015: 'Verifica importo pagamento fallita – effettua un nuovo ordine.',
  v3SubmitErrMsg120004: 'Canale di pagamento non aperto – scegli un altro metodo.',
  v3SubmitErrMsg120005: 'Canale di pagamento in manutenzione – usa un altro metodo.',
  v3SubmitErrMsg120007: 'ID piattaforma non valido – effettua di nuovo il login.',
  v3SubmitErrMsg120008: 'Parametri di richiesta insufficienti – reinvia.',
  v3SubmitErrMsg120013: 'Numero ordine sviluppatore non valido – effettua un nuovo ordine.',
  v3SubmitErrMsg120018: 'Pagamento bloccato dal controllo del rischio – contatta l\'assistenza per la verifica.',
  v3SubmitErrMsg120019: 'Verifica nome pacchetto fallita – usa la versione ufficiale.',
  v3SubmitErrMsg120021: 'Verifica ID prodotto fallita – seleziona di nuovo.',
  v3SubmitErrMsg120023: 'Errore nella consegna del regalo pre-registrazione – controlla più tardi.',
  v3SubmitErrMsg120026: 'Account non trovato – controlla lo stato dell\'account.',
  v3SubmitErrMsg120030: 'Stock totale insufficiente – scegli un altro articolo.',
  v3SubmitErrMsg120031: 'Hai superato il limite d\'acquisto per questo articolo – modifica.',
  v3SubmitErrMsg120032: 'Versione del gioco troppo vecchia – scarica l\'ultima versione.',
  v3SubmitErrMsg120080: 'Pagamento tramite agente limitato dal controllo del rischio – usa il tuo metodo di pagamento.',
  v3SubmitErrMsg120081: 'Pagamento tramite agente ritardato dal controllo del rischio – controlla il risultato più tardi.',
  v3SubmitErrMsg121002: 'Cache ordine non valido – effettua un nuovo ordine.',
  v3SubmitErrMsg121003: 'Configurazione ricarica non trovata – contatta l\'assistenza.',
  v3SubmitErrMsg121004: 'Parametri estesi insufficienti – reinvia.',
  v3SubmitErrMsg121005: 'Scrittura cache fallita – riprova più tardi.',
  v3SubmitErrMsg121006: 'Lettura cache fallita – riprova più tardi.',
  v3SubmitErrMsg121007: 'Errore di configurazione del tipo di ricarica – contatta l\'assistenza.',
  v3SubmitErrMsg121011: 'Rilevati nuovi campi da Apple – aggiorna l\'app.',
  v3SubmitErrMsg121013: 'Ordine di rinnovo non trovato – riabbonati.',
  v3SubmitErrMsg121014: 'Decrittazione parametri ricarica fallita – reinvia.',
  v3SubmitErrMsg121017: 'Questo ordine è stato rimborsato – contatta l\'assistenza per conferma.',
  v3SubmitErrMsg121018: 'Abbonamento scaduto – riabbonati.',
  v3SubmitErrMsg121020: 'Ordine annullato – effettua un nuovo ordine.',
  v3SubmitErrMsg121021: 'Errore API Google – riprova più tardi.',
  v3SubmitErrMsg121022: 'Impossibile ottenere il token di accesso – effettua di nuovo il login.',
  v3SubmitErrMsg121023: 'Stato dell\'ordine anomalo – controlla lo stato di accredito.',
  v3SubmitErrMsg121024: 'Conferma ordine fallita – riprova più tardi.'
};
